module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAAAAAByj52zAAABMElEQVR4AZ3Szw6cIBCAcd//+fawYJhBqLpg1z8Mg9dqtmu1Qpr0u5H8kgmTqcI1ihSuXQWnZVwSFwWtg1FSmWGlvCBqhQANQrREWZFeD7R7+HilnOBRgv0EcuSMSK2032Sb7iKONR4C6zHeBDthDmGE47vw8iSkz4na/qn+T/HvKaI5RCMyggKqQygMlNmYe5rvkKdL4S6IUJgPEEiUEYEXBWYHoBbO3wcT4iYQiUsXFDVsAnSkvKB1Br0JDfNKGcEpegC7B+Bj4r8ER99oqX7/RUnd+MgnQTxgLeG0dZA1DkxfEckqZX5cM6q2FD+CJ61s13Xtue1tlZ54FxQMdn2uDk2gTbBrXKnGcago9L0v1feBKpp7VxSun3fhh5+lBr+L5T2Wey9UhTDN5aYQfgFV2+yBGFMRrwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_thumb_default.png
// module id = 457
// module chunks = 0